import axios, { AxiosResponse } from "axios";
import environment from "../config";
import UserMasConfirm from "../entities/UserMasConfirm";
import axiosUtil from "../utils/helpers/axiosUtil";
import dal from "../middleware/DAL";

export async function getMasConfirmsById() {
  try {
    const body = {
      fundCode: null,
    };
    const path =
      environment.BASE_URL + "MemberDataWareHouse/GetDolTaxDeclaration";
    const res: AxiosResponse<any> = await dal.post(path, body);
    if (axiosUtil.isSuccess(res) && res?.data?.dataRows?.length) {
      const userMasConfirms = res.data.dataRows;
      return userMasConfirms.sort((a: UserMasConfirm, b: UserMasConfirm) => {
        return b.dolreportyear - a.dolreportyear;
      });
    }
    return [];
  } catch (err) {
    console.log(err);
  }
}
